module.exports = __webpack_public_path__ + "static/img/group08.17a00cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group08.jpg
// module id = Ljoa
// module chunks = 0